(() => {
  const initNavigation = (navigation) => {
    if (navigation.dataset.initialized === 'true') return;

    const links = [...navigation.querySelectorAll('a[href^="#"]')];
    const items = links
      .map((link) => ({ link, target: document.querySelector(link.getAttribute('href')) }))
      .filter((item) => item.target);

    if (!items.length) return;

    navigation.dataset.initialized = 'true';
    let activeTarget = null;
    let updateTimer = null;

    const setActive = (item) => {
      if (!item || item.target === activeTarget) return;
      activeTarget = item.target;

      items.forEach(({ link, target }) => {
        const isActive = target === activeTarget;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });

      if (navigation.scrollWidth > navigation.clientWidth) {
        const left = item.link.offsetLeft - (navigation.clientWidth - item.link.offsetWidth) / 2;
        navigation.scrollTo({ left: Math.max(0, left), behavior: 'auto' });
      }
    };

    const updateActive = () => {
      updateTimer = null;
      const marker = window.innerHeight * 0.35;
      let current = items[0];

      items.forEach((item) => {
        if (item.target.getBoundingClientRect().top <= marker) current = item;
      });

      setActive(current);
    };

    const requestUpdate = () => {
      if (updateTimer) return;
      updateTimer = window.setTimeout(updateActive, 16);
    };

    items.forEach((item) => {
      item.link.addEventListener('click', (event) => {
        event.preventDefault();
        item.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', item.link.getAttribute('href'));
        setActive(item);
      });
    });

    const observer = new IntersectionObserver(requestUpdate, {
      rootMargin: '-20% 0px -65% 0px',
      threshold: 0,
    });
    items.forEach(({ target }) => observer.observe(target));

    document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('scrollend', updateActive);
    updateActive();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-lola-world-nav]').forEach(initNavigation);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();